import React, { useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  Button,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";
import { Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { resetPassword } from "../../helpers/firebaseAuth";

import porcherMark from "../../assets/images/porcher-logo.png";
import porcherWordmark from "../../assets/images/porcher-wordmark.png";

const ForgetPasswordPage = () => {
  // Meta title
  document.title = "Forgot Password | Porcher";

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setError("");
      setSuccess("");
      setLoading(true);
      try {
        await resetPassword(values.email);
        setSuccess("Password reset email sent. Check your inbox.");
      } catch (err) {
        if (err?.code === "auth/user-not-found") {
          setError("No account found with this email.");
        } else {
          setError("Failed to send reset email. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="min-vh-100 d-flex align-items-center py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>
            <div className="text-center mb-4">
              <Link to="/" className="d-inline-flex align-items-center gap-2">
                <img src={porcherMark} alt="" height="36" />
                <img src={porcherWordmark} alt="Porcher" height="20" />
              </Link>
              <h5 className="mt-3 mb-0 fw-semibold">Forgot your password?</h5>
              <p className="text-muted small">Enter your email to receive a reset link</p>
            </div>

            <Card className="border-0 shadow-sm">
              <CardBody className="p-4">
                <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  {success && <Alert color="success">{success}</Alert>}
                  {error && <Alert color="danger">{error}</Alert>}
                  <div className="mb-3">
                    <Label className="form-label small fw-semibold">Email</Label>
                    <Input
                      name="email"
                      placeholder="you@example.com"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={validation.touched.email && !!validation.errors.email}
                    />
                    {validation.touched.email && validation.errors.email && (
                      <FormFeedback>{validation.errors.email}</FormFeedback>
                    )}
                  </div>
                  <Button color="primary" className="w-100" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Send Reset Link"}
                  </Button>
                </Form>
              </CardBody>
            </Card>

            <p className="text-center text-muted small mt-4 mb-2">
              Remember your password?{" "}
              <Link to="/login" className="text-primary fw-semibold">Sign in</Link>
            </p>
            <p className="text-center text-muted small mb-0">
              © {new Date().getFullYear()} Porcher
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPasswordPage;
